// extracted by mini-css-extract-plugin
module.exports = {"row":"FlexSystem_row__279Wk","col":"FlexSystem_col__224GR"};